module.exports = __webpack_public_path__ + "img/web-and-file.0ed2cb72.webp";